import * as z from "zod"

import { safelyExtractEnvVar } from "@repo/utils"

const sharedConfigSchema = z.object({
  appName: z.string(),
  appEnv: z.string(),
  appVersion: z.string(),
  baseUrl: z.url(),
  captchaSiteKey: z.string().optional(),
  contactEmail: z.email(),
  posthog: z.object({
    apiKey: z.string().optional(),
    apiHost: z.string(),
    uiHost: z.string(),
  }),
  flags: z.object({
    captchaEnabled: z.string().transform((value) => value === "true"),
    notificationsEnabled: z.string().transform((value) => value === "true"),
    realtimeNotificationsEnabled: z
      .string()
      .transform((value) => value === "true"),
    signUpsEnabled: z.string().transform((value) => value === "true"),
    versionCheckEnabled: z.string().transform((value) => value === "true"),
  }),
  versionCheckInterval: z
    .string()
    .transform((value) => Number.parseInt(value, 10))
    .pipe(z.number().int().positive()),
})

export const sharedConfig = sharedConfigSchema.parse({
  appName: safelyExtractEnvVar(["VITE_APP_NAME", "APP_NAME"], "Media Matters"),
  appEnv: safelyExtractEnvVar(["VITE_APP_ENV", "APP_ENV"], "development"),
  appVersion: safelyExtractEnvVar(["VITE_APP_VERSION", "APP_VERSION"], "dev"),
  baseUrl: safelyExtractEnvVar(["VITE_BASE_URL", "BASE_URL"]),
  contactEmail: safelyExtractEnvVar(
    ["VITE_CONTACT_EMAIL"],
    "info@regaldigital.net",
  ),
  captchaSiteKey: safelyExtractEnvVar("VITE_CAPTCHA_SITE_KEY"),
  posthog: {
    apiKey: safelyExtractEnvVar("VITE_POSTHOG_KEY"),
    apiHost: safelyExtractEnvVar("VITE_POSTHOG_INGEST_URL"),
    uiHost: safelyExtractEnvVar("VITE_POSTHOG_UI_HOST"),
  },
  flags: {
    captchaEnabled: safelyExtractEnvVar("VITE_FLAG_CAPTCHA_ENABLED", "false"),
    notificationsEnabled: safelyExtractEnvVar(
      "VITE_FLAG_NOTIFICATIONS_ENABLED",
      "true",
    ),
    realtimeNotificationsEnabled: safelyExtractEnvVar(
      "VITE_FLAG_REALTIME_NOTIFICATIONS_ENABLED",
      "true",
    ),
    signUpsEnabled: safelyExtractEnvVar("VITE_FLAG_SIGN_UPS_ENABLED", "true"),
    versionCheckEnabled: safelyExtractEnvVar(
      "VITE_FLAG_VERSION_CHECK_ENABLED",
      "false",
    ),
  },
  versionCheckInterval: safelyExtractEnvVar(
    "VITE_VERSION_CHECK_INTERVAL",
    "300000", // 5 minutes in milliseconds
  ),
})
